<section
    class="relative flex items-center bg-cover bg-no-repeat"
    [class]="backgroundColorClass()"
    [style.background-image]="backgroundImage() ? 'url(' + backgroundImage() + ')' : 'none'"
    [style.background-position]="backgroundPosition()"
    [style.min-height]="minHeight()"
>
    @if (showOverlay()) {
        <div class="absolute inset-0" [class]="overlayBackground()"></div>
    }

    <div class="relative z-1 w-full">
        <tran-ui-content-wrapper [noLeftSpacing]="noLeftSpacing()" [noRightSpacing]="noRightSpacing()">
            <ng-content />
        </tran-ui-content-wrapper>
    </div>
</section>
